/* eslint-disable react/no-did-mount-set-state */
import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import Tabs from '../../tabs/index';
import VoucherApi from '../../../api/open-voucher';

import './index.css';

const textDeposit = {
  error: {
    icon: 'fa fa-clock-o',
    color: 'yellow',
    title: 'Hubo un problema con su solicitud',
    description: 'La confirmación no pudo se enviada, contáctate con nosotros para completar la compra.',
    note: '',
  },
  success: {
    icon: 'fa fa-check-circle',
    color: 'green',
    title: 'Gracias por tu solicitud!',
    description: 'En breve recibirás un correo con todos los datos para completar el pago de tu OPEN VOUCHER.',
    note: 'Ya podés cerrar esta ventana',
  },
};

const textCreditCard = {
  error: {
    icon: 'fa fa-exclamation-circle',
    color: 'red',
    title: 'El pago no pudo ser confirmado',
    description: 'Si consideras que es un error, contáctate con nosotros para completar la compra.',
    note: '',
  },
  success: {
    icon: 'fa fa-check-circle',
    color: 'green',
    title: 'Gracias por tu compra!',
    description: 'En breve recibirás un correo con todos los datos para redimir tu OPEN VOUCHER.',
    note: 'Ya podés cerrar esta ventana',
  },
};

class Confirmacion extends React.Component {
  state = {
    isLoading: true,
    msg: null,
    mobile: false,
  }

  queryStringToJSON = (location) => {
    const pairs = location.search.slice(1).split('&');

    const result = {};
    pairs.forEach((pair) => {
      const newPair = pair.split('=');
      result[newPair[0]] = decodeURIComponent(newPair[1] || '');
    });

    return JSON.parse(JSON.stringify(result));
  }

  componentDidMount() {
    this.setState({ mobile: (window.innerWidth < 780) });
    const { location } = this.props;
    if (location.pathname.includes('/confirmacion-iframe')) {
      this.checkState(location);
    } else {
      const params = this.queryStringToJSON(location);
      const msg = params.method === 'deposit' ? textDeposit : textCreditCard;
      this.setState({
        isLoading: false,
        msg: location.pathname.includes('/confirmacion/error')
          ? msg.error : msg.success,
      });
    }

  }

  checkState(location) {
    const { app } = this.props;
    const params = this.queryStringToJSON(location);
    if (params.status && params.refedence) {
      if (params.status === '200' && params.refedence) {
        VoucherApi.confirmPayment(params.refedence, app.token).then((res) => {
          if (res.status) {
            this.setState({
              isLoading: false,
              msg: textCreditCard.success,
            });
          } else {
            this.setState({
              isLoading: false,
              msg: textCreditCard.success,
            });
          }
        });
      } else {
        this.setState({
          isLoading: false,
          msg: textCreditCard.error,
        });
      }
    }
  }

  render() {
    const { msg, isLoading, mobile } = this.state;
    return (
      <>
        {typeof window !== 'undefined' && !window.location.pathname.includes('/confirmacion-iframe') && (
          <Tabs />
        )}
        <div className='v-background'>
          <div className='container'>
            {!mobile && (
              <>
                <br />
                <br />
              </>
            )}
            <br />
            <div className='v-confirmation center-block text-center'>
              {isLoading ? (
                <>
                  <br />
                  <span className='icon-bk'>
                    <i className='fa fa-circle-o-notch fa-spin' aria-hidden='true' />
                  </span>
                  <br />
                  <div className='v-msg'>
                    <h4 className='title'>Verificando</h4>

                  </div>
                  <br />
                  <br />
                </>

              ) : (
                <>
                  <br />
                  <span className={`icon-bk ${msg.color}`}>
                    <i className={msg.icon} />
                  </span>
                  <br />
                  <div className='v-msg'>
                    <h4 className='title'>{msg.title}</h4>
                    <p>{msg.description}</p>
                    <br />
                    <h4 className='title'>{msg.note}</h4>
                  </div>
                  <br />
                  <br />
                </>
              )}
            </div>
            <br />
            <br />
            {!mobile && (<br />)}
          </div>
        </div>
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  app: state.applicationState,
});

export default connect(mapStateToProps, null)(Confirmacion);
